/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Status_DroppedInputs */



/**
* | output |
* | --- |
* | "Dropped" |
*
* @param {Tournament_Status_DroppedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_status_dropped = /** @type {((inputs?: Tournament_Status_DroppedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Status_DroppedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonné")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retirado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desistiu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandonato")
	return /** @type {LocalizedString} */ ("Dropped")
});